import './App.css';
import { NavBar } from './Components/NavBar/NavBar';
import { About } from './Components/Section/About/About';
import { CardsProyects } from './Components/Section/CardsProyects/CardsProyects';
import { Home } from './Components/Section/Home/Home';
import { ModalCards } from './Components/Section/Cards/ModalCards/ModalCards';
import { Contact } from './Components/Section/Contact/Contact';
import { Footer } from './Components/Footer/Footer';
import StarsCanvas from './Components/Section/StarSection/StarsCanvas';
import { WhatsAppButton } from './Components/WhatsAppButton/WhatsAppButton';

function App() {
  // testeo
  return (
    <div className="backgroundDark">
      <div className="stars-background">
        <StarsCanvas />
      </div>
      <ModalCards />
      <NavBar />
      <Home />
      <About />
      <CardsProyects />
      <Contact />
      <Footer />
      <WhatsAppButton />
    </div>
  );
}

export default App;
